import React, { useEffect, useState } from 'react';
import { AlertTriangleIcon, XIcon } from 'lucide-react';
interface PrescriptionCancelBottomSheetProps {
  isOpen: boolean;
  referenceNumber: string;
  onClose: () => void;
  onConfirm: (reason: string, details: string) => void;
}
const reasons = ['I submitted the wrong prescription', 'I no longer need this request', 'I want to change the delivery method', 'I want to update my prescription details', 'Other reason'];
export function PrescriptionCancelBottomSheet({
  isOpen,
  referenceNumber,
  onClose,
  onConfirm
}: PrescriptionCancelBottomSheetProps) {
  const [reason, setReason] = useState(reasons[0]);
  const [details, setDetails] = useState('');
  useEffect(() => {
    if (!isOpen) return undefined;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  const confirmCancellation = () => {
    onConfirm(reason, details);
    setReason(reasons[0]);
    setDetails('');
  };
  return <div className="fixed inset-0 z-[210] flex items-end bg-black/50" role="dialog" aria-modal="true" aria-labelledby="cancel-prescription-title" data-id="element-5059" data-mp="1kfy1uy3w0zrn">
      <button type="button" className="absolute inset-0 cursor-default" onClick={onClose} aria-label="Close cancellation form" data-id="element-5060" data-mp="1thxl7x2dkfxr" />
      <section className="relative w-full rounded-t-3xl bg-white shadow-2xl" data-id="element-5061" data-mp="1phngenqbjvkh">
        <div className="flex justify-center pb-2 pt-3" data-id="element-5062" data-mp="11qi0k8kdp3a6">
          <span className="h-1.5 w-12 rounded-full bg-gray-300" data-id="element-5063" data-mp="11r9oqybnbyqf" />
        </div>
        <header className="flex items-start justify-between px-5 py-3" data-id="element-5064" data-mp="wt85ode7zzey">
          <div className="flex gap-3" data-id="element-5065" data-mp="1ajla45rwkvzj">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-red-50 text-red-600" data-id="element-5066" data-mp="1akmnwi0azwky">
              <AlertTriangleIcon className="h-5 w-5" aria-hidden="true" data-id="element-5067" data-mp="15qs65k49droi" />
            </span>
            <div data-id="element-5068" data-mp="i0xtb2jxw349">
              <h2 id="cancel-prescription-title" className="text-lg font-bold text-gray-900" data-id="element-5069" data-mp="e1f8s7w15u1y">Cancel prescription request?</h2>
              <p className="mt-1 text-sm text-gray-600" data-id="element-5070" data-mp="2d6yvjxv0beq2">{referenceNumber}</p>
            </div>
          </div>
          <button type="button" onClick={onClose} className="flex h-9 w-9 items-center justify-center rounded-full text-gray-500 transition-colors duration-150 hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pharmacy" aria-label="Close" data-id="element-5071" data-mp="2i48h32f9z68m">
            <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-5072" data-mp="1u7uo2tj45t0i" />
          </button>
        </header>

        <div className="space-y-4 px-5 pb-6 pt-2" data-id="element-5073" data-mp="1z65vkxlxrrfk">
          <p className="text-sm leading-6 text-gray-600" data-id="element-5074" data-mp="1z6xr68fj9p5u">You can cancel while the pharmacist has not yet approved your request. Tell us why so we can improve the service.</p>
          <label className="block text-sm font-bold text-gray-800" data-id="element-5075" data-mp="295n0hctd61ah">
            Cancellation reason
            <select value={reason} onChange={event => setReason(event.target.value)} className="mt-2 w-full rounded-lg border border-gray-300 bg-white px-3 py-3 text-sm font-medium text-gray-800 outline-none focus:ring-2 focus:ring-pharmacy" data-id="element-5076" data-mp="3fjmecu2ygwpu">
              {reasons.map(option => <option key={option} data-id="element-5077" data-mp="13xkek8xr3sqb">{option}</option>)}
            </select>
          </label>
          <label className="block text-sm font-bold text-gray-800" data-id="element-5078" data-mp="z6c7vknt2lgu">
            Additional details <span className="font-normal text-gray-500" data-id="element-5079" data-mp="z49b8hs5du35">(optional)</span>
            <textarea value={details} onChange={event => setDetails(event.target.value)} rows={3} placeholder="Share any details that can help us." className="mt-2 w-full resize-none rounded-lg border border-gray-300 px-3 py-3 text-sm text-gray-800 outline-none placeholder:text-gray-400 focus:ring-2 focus:ring-pharmacy" data-id="element-5080" data-mp="u791nww3a97a" />
          </label>
          <div className="grid grid-cols-2 gap-3 pt-1" data-id="element-5081" data-mp="b8wrc7tfyta4">
            <button type="button" onClick={onClose} className="rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm font-bold text-gray-700 transition-colors duration-150 hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pharmacy" data-id="element-5082" data-mp="bahjxrw7425c">Keep request</button>
            <button type="button" onClick={confirmCancellation} className="rounded-lg bg-red-600 px-4 py-3 text-sm font-bold text-white transition-colors duration-150 hover:bg-red-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-600 focus-visible:ring-offset-2" data-id="element-5083" data-mp="13a1h7n618qfp">Cancel request</button>
          </div>
        </div>
      </section>
    </div>;
}